
import { defineComponent } from 'vue'
import BaseCounterUp from '@/base-ui/count-up'

export default defineComponent({
  components: {
    BaseCounterUp
  },
  props: {
    panelData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  setup() {
    const counterOption1 = {
      decimalPlaces: 0,
      prefix: '' // 单位
    }
    const counterOption2 = {
      decimalPlaces: 0,
      prefix: '$'
    }
    return {
      counterOption1,
      counterOption2
    }
  }
})
